import type { Actor, TagItem } from './actor.entity';

export type TaskWorkflowStatus = 'todo' | 'in_progress' | 'blocked' | 'done';

export const TASK_WORKFLOW_STATUSES: TaskWorkflowStatus[] = ['todo', 'in_progress', 'blocked', 'done'];

export interface PriorityOption {
    value: number;
    label: string;
}

export interface Task {
    id: string;
    name: string;
    description: string;
    priority: PriorityOption;
    status: boolean;
    workflow_status?: TaskWorkflowStatus;
    assignee?: Actor | null;
    created_by?: Actor | null;
    tags?: TagItem[];
    comments_count?: number;
    created_at: string;
    updated_at: string;
    noteId?: string;
    notes?: Array<NoteInfo>;
    project_ids?: string[];
    due_date?: string;
    completed_at?: string;
}

interface NoteInfo {
    id: string;
    name: string;
}

export interface TaskComment {
    id: string;
    task_id: string;
    body: string;
    author: Actor | null;
    is_mine: boolean;
    created_at: string;
    updated_at: string;
}

export interface TaskActivityEntry {
    id: number;
    event: string | null;
    description: string;
    causer: Actor | null;
    changes: { attributes?: Record<string, unknown>; old?: Record<string, unknown> } | null;
    created_at: string;
}
